import React from 'react';
import ReactDOM from 'react-dom/client';
import {RouterProvider} from "react-router-dom";
import {Provider} from "react-redux";
import {I18nextProvider} from "react-i18next";

import './index.css';
import i18n from "./i18n";
import {router} from "./router";
import {store} from "./store";
import {AppInitializer} from "./components/AppInitializer";

// Browser tab title per brand, driven by REACT_APP_PROJECT_CODE (same env
// var config.js already switches on) — set once at module load, before
// render, so even the initial loading-spinner screen shows the right title.
// public/index.html's static <title>Admin Chef Kitchen</title> is just the
// pre-JS fallback (shown for the instant before this script runs).
const ADMIN_TITLE_BY_CODE = {
    CK: "Admin Chef Kitchen",
    E4F: "Admin Eat For Fit",
    MEELZ: "Admin Meelz",
};
document.title = ADMIN_TITLE_BY_CODE[process.env.REACT_APP_PROJECT_CODE] || ADMIN_TITLE_BY_CODE.CK;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <I18nextProvider i18n={i18n}>
        <Provider store={store}>
            <AppInitializer>
                <RouterProvider router={router}/>
            </AppInitializer>
        </Provider>
    </I18nextProvider>
);


